<template>
  <section class="page-top">
    <v-container>
      <div class="animated-shape">
        <v-lottie :options="animationOptions"></v-lottie>
      </div>
      <div class="page-top__info">
        <v-heading level="h2" weight="regular" class="page-top__hat">{{hat}}</v-heading>
        <v-heading level="h2" class="page-top__title">{{title}}</v-heading>
        <p v-if="description">{{description}}</p>
        <slot />
      </div>
    </v-container>
  </section>
</template>

<script>
import Lottie from 'vue-lottie';
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import animationData from '@/assets/json/animation.json';

export default {
  name: 'PageTop',
  components: {
    'v-container': Container,
    'v-heading': Heading,
    'v-lottie': Lottie,
  },
  props: {
    hat: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      animationOptions: {
        loop: false,
        animationData,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
$component: '.page-top';
#{$component} {
  background-color: $color-sys-k;
  .container {
    display: flex;
    align-items: center;
    position: relative;
    padding: $section-gutter / 2 0 $section-gutter / 2 300px;
    min-height: 265px;
    @media screen and (max-width: #{$brakepoint-large}) {
      padding: $section-gutter / 2 $gutter-l;
    }
  }
  .animated-shape {
    position: absolute;
    left: 0;
    bottom: 0;
    transform: translate(-20%, 7px);
    @media screen and (max-width: #{$brakepoint-large}) {
      opacity: .2;
      transform: translate(-20%, 7px);
    }
    /deep/ svg {
      width: 400px !important;
      height: 247px !important;
    }
  }
  &__info {
    position: relative;
    p {
      margin: 0 0 $gutter-xxl;
      color: $color-sys-e;
      font-size: $font-size-xl;
      &:last-child {
        margin: 0;
      }
    }
  }
  &__hat {
    margin: 0;
  }
}
</style>
